/* @generated */

// src/assets/ui-icon/line/hashtag.tsx
import * as React from "react";
var HashtagLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.644 5-.65 3.5H5V10h3.715l-.743 4H4.25v1.5h3.444l-.65 3.5h1.728l.65-3.5h3.854l-.65 3.5h1.729l.65-3.5H19V14h-3.716l.744-4h3.722V8.5h-3.443l.65-3.5h-1.729l-.65 3.5h-3.855l.65-3.5H9.645Zm3.911 9 .744-4h-3.854L9.7 14h3.854Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  HashtagLine
};
